export const calculateTenure = (startDate) => {
    if (!startDate) return '-';
    const today = new Date();
    const start = new Date(startDate);
    let years = today.getFullYear() - start.getFullYear();
    let months = today.getMonth() - start.getMonth();
    
    if (months < 0) {
        years--;
        months += 12;
    }
    if (today.getDate() < start.getDate()) {
        months--;
        if (months < 0) {
            years--;
            months = 11;
        }
    }
    
    const yearText = years === 1 ? 'год' : years < 5 ? 'года' : 'лет';
    const monthText = months === 1 ? 'мес' : 'мес';
    
    return `${years} ${yearText} ${months} ${monthText}`;
};

